var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"app":"","color":"blue"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.lang.translator('copyright'))}}),_c('v-spacer'),_c('span',[_vm._v(_vm._s(_vm.$vuetify.lang.translator("version"))+" 2.7.0")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }